import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Our Tech-Stack for <span>On-Demand App</span> Development Services
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              We only opt for technologies that are novel, responsive, and
              transformative – because excellence is the minimum bar for every
              build our on demand app development company deploys.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="UI/UX Design">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/ui-ux/sketch.webp"
                    alt="Sketch"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Sketch</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/ui-ux/adobe_xd.webp"
                    alt="Adobe XD"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Adobe XD</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/ui-ux/figma.webp"
                    alt="Figma"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Figma</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/ui-ux/invision.webp"
                    alt="InVision"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>InVision</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Frontend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/frontend/flutter.webp"
                    alt="Flutter"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Flutter</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/frontend/java.webp"
                    alt="Java"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/frontend/kotlin.webp"
                    alt="Kotlin"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kotlin</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/frontend/react_native.webp"
                    alt="React Native"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>React Native</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/frontend/swift.webp"
                    alt="Swift"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Swift</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Backend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/backend/express.js.webp"
                    alt="Express js"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Express js</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/backend/node.js.webp"
                    alt="Node js"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Node js</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/backend/django.webp"
                    alt="Django"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Django</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/backend/ruby_on_rails.webp"
                    alt="Ruby on Rails"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Ruby on Rails</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/database/mongoDB.webp"
                    alt="MongoDB"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/database/mysql.webp"
                    alt="MySQL"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/database/postgresql.webp"
                    alt="PostgreSQL"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Cloud Services">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/cloud-service/amazon.webp"
                    alt="AWS"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/cloud-service/firebase.webp"
                    alt="Firebase"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/cloud-service/google_cloud_platforms.webp"
                    alt="Google Cloud"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/cloud-service/microsoft_azure.webp"
                    alt="Azure"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
